module.exports = __webpack_public_path__ + "static/media/credit-card.d9ba5338.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/credit-card.svg
// module id = 1231
// module chunks = 0